$(function () {
	APP.init();
	lozadInit();
	fancyboxInit();
	countUpInit();

	studyInit();
	recruitmentInit();
	accordionCollapse();
	contactMaps();
});

var lastScrollTop = 0;
$(window).on('scroll', function () {
	APP.fixed();
});

// $(window).on("resize", function () {
// 	studyInit();
// });

// variable
var header = $("header"),
	body = $("body"),
	backdrop = $(".backdrop"),
	toggleBackdrop = $(".toggle-backdrop"),
	backToTop = $(".back-to-top"),
	buttonMenu = $("#buttonMenu"),
	mobileWrap = $(".mobile-wrap"),
	buttonSearch = $("header .button-search"),
	searchWrap = $(".search-wrap"),
	heightHeader = $("header").height(),
	heightWindow = $(window).height(),
	widthWindow = $(window).width(),
	outerHeightWindow = $(window).outerHeight();

// toggleText
$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

var APP = {
	fixed: () => {
		// header
		var scrollTop = $(this).scrollTop();
		$(window).scrollTop() > heightHeader
			? header.addClass("active")
			: header.removeClass("active");
		// Check if the user is scrolling up or down
		if (scrollTop > lastScrollTop) {
			// Scrolling down, hide the header
			// header.css('transform', 'translateY(-100%)');
			header.removeClass("show")
		} else {
			// Scrolling up, show the header
			header.addClass("show")
		}
		// Set the last scroll position
		lastScrollTop = scrollTop;

		$(window).scrollTop() > (outerHeightWindow - heightHeader)
			? backToTop.addClass("active")
			: backToTop.removeClass("active");
		if ($('.home-number').length){
			$(window).scrollTop() > $('.home-number').offset().top - $('.home-number').height() - 100
			? $('.home-number').addClass("active")
			: $('.home-number').removeClass("active");
		}
	},
	backdrop: () => {
		backdrop.on('click', function () {
			$(this).removeClass('open');
			toggleBackdrop.removeClass('open');
			body.removeClass('overflow-hidden');
			if(widthWindow<1024)
				$('.slide-up-backdrop').slideUp();
		})
	},
	backToTop: () => {
		backToTop.on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 500);
		})
	},
	mapping: () => {
		// const mainMenu = $("header .navbar-nav").mapping({
		// 	mobileWrapper: ".mobile-wrap .navbar-nav-list",
		// 	mobileMethod: "prependTo",
		// 	desktopWrapper: "header .header-right",
		// 	desktopMethod: "prependTo",
		// 	breakpoint: 1023.98,
		// });
	},
	toggleElm: (button, elmToggle) => {
		button.on("click", function () {
			$(this).toggleClass("open");
			elmToggle.slideToggle();
			backdrop.toggleClass('open');
		});
	},
	init: () => {
		APP.backdrop();
		APP.backToTop();
		// APP.mapping();
		APP.toggleElm(buttonMenu, $('header .navbar-nav'));
	}
}

const homeBannerSlider = new Swiper(".home-banner .swiper", {
	loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	pauseOnMouseEnter: true,
	// },
	// rewind: true,
	speed: 1000,
	spaceBetween: 0,
	observer: true,
	observeParents: true,
	// effect: "fade",
	grabCursor: true,
	effect: "creative",
	creativeEffect: {
		prev: {
			shadow: true,
			translate: ["-20%", 0, -1],
		},
		next: {
			translate: ["100%", 0, 0],
		},
	},
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-banner .button-next",
		prevEl: ".home-banner .button-prev",
	},
	pagination: {
		el: ".home-banner .swiper-pagination",
		clickable: true,
	},
	keyboard: {
		enabled: true,
		onlyInViewport: false
	},
	runCallbacksOnInit: true,
	on: {
		init: function () {
			var activeIndex = this.activeIndex;
			var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
			var activeSlideVideo = activeSlide.querySelector('video');

			if (activeSlideVideo) {
				activeSlideVideo.currentTime = 0;
				activeSlideVideo.play();
				activeSlideVideo.addEventListener('ended', function () {
					homeBannerSlider.slideNext();
				});
			} else {
				setTimeout(function () {
					homeBannerSlider.slideNext();
				}, 5000);
			}
		},
		transitionStart: function () {
			// console.log("Transition start");
			var videos = document.querySelectorAll('video');
			Array.prototype.forEach.call(videos, function (video) {
				video.pause();
			});
		},
		transitionEnd: function () {
			// console.log("Transition end");
			var activeIndex = this.activeIndex;
			var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
			var activeSlideVideo = activeSlide.querySelector('video');

			if (activeSlideVideo) {
				activeSlideVideo.currentTime = 0;
				activeSlideVideo.play();
				activeSlideVideo.addEventListener('ended', function () {
					homeBannerSlider.slideNext();
				});
			} else{
				setTimeout(function () {
					homeBannerSlider.slideNext();
				}, 5000);
			}
		},
		slideChange: function () {
			// console.log("Slide change");
			var activeIndex = this.activeIndex;
			var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
			var activeSlideVideo = activeSlide.querySelector('video');
			if (activeSlideVideo) {
				activeSlideVideo.currentTime = 0;
			}
		},
	}
});

const bannerChildSlider = new Swiper(".banner-child .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".banner-child .button-next",
		prevEl: ".banner-child .button-prev",
	},
	pagination: {
		el: ".banner-child .swiper-pagination",
		clickable: true,
	},
});


const homeStorySlider = new Swiper(".home-story-swiper .swiper", {
	// loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	pauseOnMouseEnter: true,
	// },
	speed: 1000,
	spaceBetween: 32,
	observer: true,
	observeParents: true,
	// effect: "cube",
	// grabCursor: true,
	// cubeEffect: {
	// 	shadow: false,
	// 	slideShadows: true,
	// 	shadowOffset: 20,
	// 	shadowScale: 0.94,
	// },
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-story-swiper .button-next",
		prevEl: ".home-story-swiper .button-prev",
	},
	pagination: {
		el: ".home-story-swiper .swiper-pagination",
		clickable: true,
	},
});

const homeEventsThumb = new Swiper(".home-events-swiper .swiper-thumb", {
	spaceBetween: 10,
	slidesPerView: 2,
	watchSlidesProgress: true,
	breakpoints: {
		768: {
			slidesPerView: 3,
			spaceBetween: 16,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 1,
			spaceBetween: 24,
			// direction: "vertical",
			// slidesPerGroupSkip: 4,
			// slidesPerGroup: 4,
			grid: {
				// fill: 'row',
				rows: 4,
			}
		},
	},
});

const homeEventsTop = new Swiper(".home-events-swiper .swiper-top", {
	speed: 1000,
	spaceBetween: 10,
	slidesPerView: 1,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-events-swiper .button-next",
		prevEl: ".home-events-swiper .button-prev",
	},
	pagination: {
		el: ".home-events-swiper .swiper-pagination",
		clickable: true,
		dynamicBullets: true,
	},
	thumbs: {
		swiper: homeEventsThumb,
	},
	// breakpoints: {
	// 	1280: {
	// 		pagination: {
	// 			dynamicBullets: false,
	// 		}
	// 	},
	// }
});

const homeNewsSlider = new Swiper(".home-news .swiper", {
	// loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	pauseOnMouseEnter: true,
	// },
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 16,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-news .button-next",
		prevEl: ".home-news .button-prev",
	},
	pagination: {
		el: ".home-news .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 16,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 32,
		},
	},
});

const preschool2Slider = new Swiper(".preschool-2-swiper .swiper", {
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 16,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".preschool-2-swiper .button-next",
		prevEl: ".preschool-2-swiper .button-prev",
	},
	pagination: {
		el: ".preschool-2-swiper .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 16,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 32,
		},
	},
});

const preschool2DetailSlider = new Swiper(".preschool-2-detail-swiper .swiper", {
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 16,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".preschool-2-detail-swiper .button-next",
		prevEl: ".preschool-2-detail-swiper .button-prev",
	},
	pagination: {
		el: ".preschool-2-detail-swiper .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 2.5,
			spaceBetween: 16,
		},
		1024: {
			slidesPerView: 2.5,
			spaceBetween: 24,
		},
		1280: {
			slidesPerView: 2.5,
			spaceBetween: 32,
		},
	},
});

const admissionsSlider = new Swiper(".admissions-1-swiper .swiper", {
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 16,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".admissions-1-swiper .button-next",
		prevEl: ".admissions-1-swiper .button-prev",
	},
	pagination: {
		el: ".admissions-1-swiper .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 24,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 32,
		},
	},
});

const newsOtherSlider = new Swiper(".news-other-swiper .swiper", {
	// loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	pauseOnMouseEnter: true,
	// },
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 16,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".news-other-swiper .button-next",
		prevEl: ".news-other-swiper .button-prev",
	},
	pagination: {
		el: ".news-other-swiper .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 16,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 32,
		},
	},
});

const contactSlider = new Swiper(".contact-swiper .swiper", {
	loop: true,
	autoplay: {
		delay: 1,
		disableOnInteraction: false,
		pauseOnMouseEnter: false,
	},
	speed: 8000,
	slidesPerView: 2,
	spaceBetween: 16,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".contact-swiper .button-next",
		prevEl: ".contact-swiper .button-prev",
	},
	pagination: {
		el: ".contact-swiper .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 16,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 32,
		},
		1440: {
			slidesPerView: 4,
			spaceBetween: 32,
		},
	},
});

const recruitment2Slider = new Swiper(".recruitment-2-swiper .swiper", {
	// loop: true,
	// autoplay: {
	// 	delay: 5000,
	// 	disableOnInteraction: false,
	// 	pauseOnMouseEnter: true,
	// },
	speed: 1000,
	slidesPerView: 1,
	spaceBetween: 0,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".recruitment-2-swiper .button-next",
		prevEl: ".recruitment-2-swiper .button-prev",
	},
	pagination: {
		el: ".recruitment-2-swiper .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 3,
		},
		1280: {
			slidesPerView: 4,
		},
	},
});

function lozadInit() {
	// Initialize library to lazy load images
	const observer = lozad('.lozad', {
		threshold: 0.1,
		enableAutoReload: true,
	});
	// data-background-image="image.png"
	const backgroundObserver = lozad('.lozad-bg', {
		threshold: 0.1,
	});
	observer.observe();
	backgroundObserver.observe();
}

function fancyboxInit() {
	Fancybox.bind("[data-fancybox]", {
		showLoading: true,
		preload: true,
		infinite: false,
		// parentEl: document.forms[0], // Element containing main structure
		mainClass: "fancybox-wrapper", // Custom class name or multiple space-separated class names for the container
	});

	Fancybox.bind("a.popup-link", {
		showLoading: true,
		type: "iframe",
		preload: true,
	});

	Fancybox.bind('[data-fancybox="single"]', {
		groupAttr: false,
	});

	$(".btn-close-fancybox").on("click", function () {
		Fancybox.close();
	});
}

function countUpInit() {
	$('.count-up').each(function (index) {
		$(this).attr('id', `countUp-${index}`)
		const endVal = $(this).data('count');

		const options = {
			separator: '',
			enableScrollSpy: true,
			scrollSpyDelay: 1000,
			scrollSpyOnce: true,
		};

		const countUp = new CountUp(`countUp-${index}`, endVal, options);

		if (!countUp.error) {
			countUp.start();
		} else {
			console.error(countUp.error);
		}

		countUp.handleScroll();
	});
}

function accordionCollapse() {
	$('.accordion-item').on('click', function () {
		$(this)
			.toggleClass('active')
			.siblings().removeClass('active')
		$(this)
			.find('.accordion-content').slideToggle()
			.parents('.accordion-item')
			.siblings().find('.accordion-content').slideUp()
	});

	$('.accordion-item:nth-child(1)').trigger('click')
}

function studyInit(){
	if(widthWindow<1280){
		$('.study-item').on('click', function () {
			let studyId = $(this).data('study');
			console.log(`#${studyId}`);
			const fancyboxEvents = new Fancybox([
				{
					src: `#${studyId}`,
					type: "inline",
					showLoading: true,
					preload: true,
					infinite: false,
				},
			]);
		})
	} else {
		$('.study-item').hover(function(){
			let studyId = $(this).data('study')
			$('.study-popup-item').removeClass('active');
			$(`.study-popup-item[id='${studyId}']`).addClass('active')
		})
		$('.study-popup-item .study-popup-close').on('click', function(){
			$(this).parents('.study-popup-item').removeClass('active')
		});
		$('.study-popup-item').on('mouseleave', function(){
			$(this).removeClass('active')
		})
	}
}

function recruitmentInit(){
	$('.recruitment-2-item').on('mouseenter', function(){
		$('.recruitment-2-item').removeClass('hover');
		$(this).addClass('hover');
	})
}

function contactMaps(){
	$('.contact-item').on('click', function(){
		// contactSlider.autoplay.pause();
		let dataIframe = $(this).data('iframe')
		$('.contact-item').removeClass('active')
		$(this).addClass('active')
		$('.contact-maps iframe').attr('src', dataIframe)
	})
}
